import { render, staticRenderFns } from "./group_details.vue?vue&type=template&id=b1f3f1be&"
import script from "./group_details.vue?vue&type=script&lang=js&"
export * from "./group_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports